import axios from "axios";

const ADMIN_URL = process.env.REACT_APP_ADMIN_APIURL;

const getStats = async (userData) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${ADMIN_URL}/get-stats`, config);
  return result;
};

const adminService = {
  getStats,
};

export default adminService;
